import { Map as IMap, fromJS } from 'immutable';


export const REQUEST_CONSUMER_FEES = '@@storefront/REQUEST_CONSUMER_FEES';
export const SET_CONSUMER_FEES = '@@storefront/SET_CONSUMER_FEES';
export const CONSUMER_FEES_FETCH_FAILED = '@@storefront/CONSUMER_FEES_FETCH_FAILED';


const feeReducer = (state = IMap(), action) => {
    switch (action.type) {
        case SET_CONSUMER_FEES: {
            return state.merge({
                consumerFees: fromJS(action.fees),
                currencyCode: action.currencyCode
            });
        }
        default:
    }
    return state;
};


export const requestConsumerFees = currencyCode => ({
    type: REQUEST_CONSUMER_FEES,
    currencyCode
});

export const setConsumerFees = (fees, currencyCode) => ({
    type: SET_CONSUMER_FEES,
    fees,
    currencyCode
});

export const consumerFeesFetchFailed = () => ({
    type: CONSUMER_FEES_FETCH_FAILED
});

export default feeReducer;
